import React, { useState } from 'react';
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';
import styles from './PasswordInput.module.css';

// Drop-in replacement for <input type="password">: same props, plus a
// show/hide toggle. Every password field in the app should use this.
function PasswordInput(props) {
  const [visible, setVisible] = useState(false);

  return (
    <span className={styles.wrap}>
      <input {...props} type={visible ? 'text' : 'password'} />
      <button
        type="button"
        className={styles.toggle}
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? 'Hide password' : 'Show password'}
        aria-pressed={visible}
        title={visible ? 'Hide password' : 'Show password'}
      >
        {visible ? <EyeSlashIcon /> : <EyeIcon />}
      </button>
    </span>
  );
}

export default PasswordInput;
